var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[(!_vm.$vuetify.theme.dark)?_c('img',{staticClass:"logo",attrs:{"alt":"SCM logo","src":require("../assets/logoTagline.png")}}):_c('img',{staticClass:"logo",attrs:{"alt":"SCM logo","src":require("../assets/logoTaglineNegativo.png")}}),_c('h1',[_vm._v(_vm._s(_vm.getTranslated('_welcome')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }